import { BaseActionType, Product } from '@/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  adjustInventory,
  fetchProductById,
  refetchProductById,
} from '../actions/singleProductActions';
import { Platform } from '@/enums/platform';

interface SingleProductState {
  selectedProduct?: Product;
  loading: boolean;
  isStandAlone: boolean;
  isWooCommerce: boolean;
  categories: string[];
}

const initialState: SingleProductState = {
  selectedProduct: undefined,
  loading: false,
  isStandAlone: false,
  isWooCommerce: false,
  categories: [],
};

export const singleProductSlice = createSlice({
  name: 'singleProduct',
  initialState: initialState,
  reducers: {
    clearSingleProduct: (state) => {
      state.selectedProduct = undefined;
      state.isStandAlone = true;
      state.isWooCommerce = false;
    },
    changeCategories: (state, action: PayloadAction<string[]>) => {
      state.categories = action.payload;
    },
  },
  extraReducers: (builder) => {
    (builder.addCase(fetchProductById.pending, (state) => {
      state.loading = true;
    }),
      builder.addCase(fetchProductById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedProduct = action.payload;
        state.isStandAlone =
          action.payload?.source === Platform.STAND_ALONE || action.payload === undefined;
        state.isWooCommerce = action.payload?.source === Platform.WOO_COMMERCE;
      }),
      builder.addCase(fetchProductById.rejected, (state) => {
        state.loading = false;
      }),
      builder.addCase(refetchProductById.fulfilled, (state, action) => {
        state.selectedProduct = action.payload;
        state.isStandAlone =
          action.payload?.source === Platform.STAND_ALONE || action.payload === undefined;
        state.isWooCommerce = action.payload?.source === Platform.WOO_COMMERCE;
      }),
      builder.addCase(
        adjustInventory.fulfilled,
        (
          state,
          action: PayloadAction<
            | {
                variantId: string;
                outletId: string;
                quantity: number;
                baseAction: BaseActionType;
              }
            | undefined
          >,
        ) => {
          if (action.payload && state.selectedProduct) {
            const variantIndex = state.selectedProduct.variants?.findIndex(
              (variant) => variant._id === action.payload?.variantId,
            );

            if (variantIndex !== undefined && variantIndex !== -1) {
              const outletIndex = state.selectedProduct.variants[variantIndex].inventory?.findIndex(
                (outlet) => outlet.outletId === action.payload?.outletId,
              );

              if (outletIndex !== undefined && outletIndex !== -1) {
                state.selectedProduct.variants[variantIndex].inventory[outletIndex].stock =
                  action.payload.baseAction === 'RECOUNT'
                    ? action.payload.quantity
                    : state.selectedProduct.variants[variantIndex].inventory[outletIndex].stock +
                      action.payload.quantity;
              }
            }
          }
        },
      ));
  },
});

export const { clearSingleProduct, changeCategories } = singleProductSlice.actions;

export default singleProductSlice.reducer;
